<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb
            :title="page.title"
            :breadcrumbs="breadcrumbs"
         ></BaseBreadcrumb>
         <v-card>
            <v-card-title>Payment Status</v-card-title>
            <v-card-text>
               <v-alert :type="alertType" dense text>
                  {{ statusMessage }}
               </v-alert>
               <v-simple-table dense v-if="billinfo">
                  <template v-slot:default>
                     <tbody>
                        <tr>
                           <th class="text-left">Transaction No.</th>
                           <td>{{ billinfo.trxnid }}</td>
                        </tr>
                        <tr>
                           <th class="text-left">Description</th>
                           <td>{{ billinfo.description }}</td>
                        </tr>
                        <tr>
                           <th class="text-left">Amount</th>
                           <td>RM {{ Number(billinfo.amount || 0).toFixed(2) }}</td>
                        </tr>
                        <tr>
                           <th class="text-left">Pay Year</th>
                           <td>{{ billinfo.payyear || '-' }}</td>
                        </tr>
                     </tbody>
                  </template>
               </v-simple-table>
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn color="primary" :href="returnPath">{{ returnLabel }}</v-btn>
            </v-card-actions>
         </v-card>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'

export default {
   name: "MOMPaymentThankyou",
   components: {
      DashboardLayout,
      BaseBreadcrumb,
   },
   props: {
      billinfo: { type: Object, default: null },
      status_id: { type: [String, Number], default: null },
      memberinfo: { type: Object, default: null },
   },
   data() {
      return {
         page: { title: "Payment Status" },
         breadcrumbs: [
            { text: "Dashboard", disabled: false, to: "/dashboard" },
            { text: "Payments", disabled: false, to: "/member/payments" },
            { text: "Payment Status", disabled: true },
         ],
      }
   },
   computed: {
      isNewApplicationPayment() {
         return this.memberinfo
            && parseInt(this.memberinfo.memberstatus || 0) === 0
            && parseInt(this.memberinfo.hasapplied || 0) !== 1
      },

      returnPath() {
         return this.isNewApplicationPayment ? '/dashboard' : '/member/payments'
      },

      returnLabel() {
         return this.isNewApplicationPayment ? 'Continue Registration' : 'Back to Payments'
      },

      alertType() {
         if (String(this.status_id) === '1') return 'success'
         if (String(this.status_id) === '3') return 'error'
         if (!this.status_id || this.status_id === 'null') return 'error' // ✅ null = cancel
         return 'info'
      },
      statusMessage() {
         if (String(this.status_id) === '1') {
            return this.isNewApplicationPayment
               ? 'Payment successful. Please continue and submit your membership registration.'
               : 'Payment successful. Your membership has been activated.'
         }
         if (String(this.status_id) === '3' || !this.status_id || this.status_id === 'null')
            return 'Payment was not completed. Please try again or register your receipt manually.' // ✅
         return 'Payment is pending. Please wait for admin verification or payment gateway confirmation.'
      },
   },
}
</script>
